module.exports = __webpack_public_path__ + "static/media/unassign-role.2a55c57f.svg";